import clsx from 'clsx';
import { NavLink } from 'react-router-dom';
import styles from './SectionNav.module.scss';

export type SectionNavItem = {
  title: string;
  path: string;
};

type SectionNavProps = {
  items: SectionNavItem[];
  /** Optional label above the list, e.g. "Topics". */
  heading?: string;
};

/**
 * In-page navigation for a section's topics.
 *
 * Replaces the older `SidebarNavigation`, which renders a fixed-position MUI
 * drawer — that forces every page using it to reserve left padding by hand and
 * leaves the list stranded at the top of the viewport. This is an ordinary
 * sticky column, so the page owns its own layout and the list stays visible
 * beside long content.
 */
export function SectionNav({ items, heading }: SectionNavProps) {
  return (
    <nav className={styles.nav} aria-label={heading ?? 'Section'}>
      {heading && <p className={styles.heading}>{heading}</p>}
      {items.map(item => (
        <NavLink
          key={item.path}
          to={item.path}
          className={({ isActive }) =>
            clsx(styles.item, isActive && styles.itemActive)
          }
        >
          {item.title}
        </NavLink>
      ))}
    </nav>
  );
}

export default SectionNav;
